export default [
  {
    path: 'data/datasets',
    name: 'Datasets',
    component: () => import('@/app/dataset/views/DatasetsView.vue'),
  },
  {
    path: 'data/datasets/new',
    name: 'AddDataset',
    component: () => import('@/app/dataset/views/NewDatasetView.vue'),
  },
  {
    path: 'data/datasets/:id',
    name: 'DatasetDetail',
    component: () => import('@/app/dataset/views/DatasetDetailView.vue'),
  },
  {
    path: 'data/datasets/:id/permissions',
    name: 'DatasetPermissions',
    component: () => import('@/app/dataset/views/DatasetPermissionsView.vue'),
    props: true
  },
];